import {Vue} from 'ui.vue';
import {Vuex} from 'ui.vue.vuex';


import store from './store/index';
import './components/login/BXmakerAuthuseremailLogin.js';


export class Login {
    constructor(rootId, data ) {
        this.rootId = rootId;
        this.data = data;
        this.rand = data.rand;
        this.instance = null;
        this.store = store;
        this.store.commit('bxmaker/authuseremail/login/setValues', data);

        this.initTemplate()
    }

    initTemplate() {
        const context = this;

        this.instance = Vue.createApp({
            name: 'BXmakerAuthuseremailLoginContainer' + this.rand,
            data(){
                return Object.freeze({
                    'data': context.data,
                });
            },
            computed:{
                localize()
                {
                    return BX.Vue.getFilteredPhrases('BXMAKER_AUTHUSEREMAIL_');
                }
            },
            store: context.store,
            template: `<BXmakerAuthuseremailLogin :data="data" :key="data.rand"  />`,
        });

        this.instance.mount( '#' + this.rootId);

        return new Promise((resolve, reject) => resolve());
    }

}